import { debounce } from '@mui/material/utils';
import {
  IMiddleware,
  MiddlewareContext,
  NextFunction,
} from '../middleware-manager';
import { isUnauthorized } from '../../utils';

const dispatchForceReauth = debounce(
  () => window.dispatchEvent(new CustomEvent('forceReauthFromApp')),
  500,
);

export class AuthHandlerMiddleware implements IMiddleware {
  async onResponse(
    context: MiddlewareContext,
    next: NextFunction,
  ): Promise<void> {
    await next();
    if (isUnauthorized(context.response?.status || 0)) {
      dispatchForceReauth();
    }
  }
}
